import React from "react";
import { AppBar, Toolbar } from "@material-ui/core";
import ImageFundacion from "../assets/isologo.png"
import "../Style/NavBar.css";

const Navbar = () => (
  <React.Fragment>
    <AppBar className="Navbar Navbar__Container" position="absolute">
      <Toolbar className="Navbar__Toolbar">
        <div className="Navbar__Logo">
          <a className="Navbar__Logo__Link" href="/">
            <strong>
              <span>DIMENSIONÁ TU ESFUERZO</span>
            </strong>
          </a>
        </div>
        <img
        className="Navbar-Image"
        src={ImageFundacion}
      ></img>
      </Toolbar>
    </AppBar>
    <Toolbar />
  </React.Fragment>
);

export default Navbar;
